var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-text-banner"
  }, [_c('div', {
    staticClass: "text-area"
  }, [_c('div', {
    staticClass: "text-area-left"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "text-area-right"
  }, [_vm._t("right", [_c('p', [_c('span', [_vm._v("申请人：" + _vm._s(_vm.user.name))]), _vm._v(" "), _c('span', {
    staticClass: "ml-20"
  }, [_vm._v("签约部门：" + _vm._s(_vm.user.sysTypeName))])])])], 2)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-800c7a06"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/textBanner.vue
// module id = null
// module chunks = 